import { Select, TreeProps } from 'antd'
import React, { useState } from 'react'
import SliderComp from '../../components/SliderComp';
import ButtonIcon from '../../components/ButtonComp';
import { faSun } from '@fortawesome/free-solid-svg-icons';
import useConfirm from '../../hooks/useConfirm';
import { IAsset } from '../../models/Assets';
import { sendBrightness } from '../../api/its/pmv';

type Props = {
    checkedKeys: TreeProps['checkedKeys'];
    assetsPMV: IAsset[];
}

const BrightnessComp: React.FC<Props> = ({ checkedKeys, assetsPMV }: Props) => {
    const { showPromiseConfirm } = useConfirm();
    const [brightness, setBrightness] = useState<number>(0);
    const [brightnessType, setBrightnessType] = useState<'Manual' | 'Automatic'>('Automatic');

    const handleBrightness = () => {
        const content = (
            <>
                <p>¿Está seguro que desea actualizar el brillo de estos paneles?</p>
                <ul>
                    {Array.isArray(checkedKeys) && checkedKeys.map(panel_id => {
                        const panel = assetsPMV.find(asset => asset.id === panel_id);
                        return <li key={panel_id}>{panel?.description}</li>
                    })}
                </ul>
            </>
        );

        showPromiseConfirm({
            title: 'Actualizar panel(es)',
            content,
            okText: 'Actualizar brillo',
            actionCallback: async () => {
                if (Array.isArray(checkedKeys))
                    for (const panel of assetsPMV.filter(asset => checkedKeys.includes(asset.id))) {
                        sendBrightness(panel.id, brightnessType, brightness);
                    }
            }
        });
    }
    return (
        <>
            <Select
                value={brightnessType}
                onChange={(value) => setBrightnessType(value)}
                style={{ width: "100%", marginBottom: "10px" }}
            >
                <Select.Option value="Manual">Manual</Select.Option>
                <Select.Option value="Automatic">Automático</Select.Option>
            </Select>
            <SliderComp min={0} max={100} brightness={brightness} setBrightness={setBrightness} /><br />
            <ButtonIcon
                icon={faSun}
                name="Ajustar brillo"
                variant="outline-success"
                size="sm"
                onClick={handleBrightness}
            />
        </>
    )
}

export default BrightnessComp